import {StackLayout} from "@progress/kendo-react-layout";
import {useLayoutEffect, useState} from "react";
import GroupsGrid from "./GroupsGrid";

const Users = props => {

    const menuSize = props.menuSize
    const [refSize, setRefSize] = useState({width:0, height:0});


    const handleSize = () => {
        // debugger
        let width = window.innerWidth - 10;
        const height = window.innerHeight;
        setRefSize({
            // width: ref.current.offsetWidth,
            // height: ref.current.offsetHeight
            width: width,
            height: height
        })
        console.log(refSize.width, width, window.innerWidth)
    }

    useLayoutEffect(() => {
        handleSize()
        window.addEventListener("resize", handleSize);
        return () => window.removeEventListener("resize", handleSize);
    }, []);


    return(
        <>


                <StackLayout
                    style={{
                        height: "calc(100vh - 55px)",
                        width: "100%"
                    }}
                    orientation={"vertical"}
                    gap={0}
                >

                    <GroupsGrid size={refSize} menuSize={menuSize} dataType={"all"}></GroupsGrid>

                </StackLayout>



        </>
    )
}

export default Users